// extracted by mini-css-extract-plugin
export default {"container":"container___l7_w5dSmghA","logo":"logo__OW8CBaNHpkHb","body":"body__G8WPdX0ld3f7","img":"img__vRJZyQ5eGU6K","link":"link__F2NvCTj1LWwE"};